import Header from "components/Headers/Header";
import TabsInfoModal from "components/Modal/TabsInfoModal";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Col, Container, Row } from "reactstrap";
import { getRatings } from "store/actions/ratingsAction";

const ChatRating = () => {
  const infoPoints = [
    "Once chats conclude and athletes receive ratings from fans, this module allows the admin to monitor overall athlete ratings. The numbers are displayed in separate cards based on their ratings and total number of chats.",
  ];
  const subPoints = [];
  const infoTitle = "Chat Rating Information";
  const [infoModalOpen, setInfoModalOpen] = useState(false);

  let dispatch = useDispatch();
  useEffect(() => {
    dispatch(getRatings());
  }, []);
  const { rating } = useSelector((state) => state.rating);
  return (
    <>
      <Header />
      <Container className="mb-5" fluid>
        <Row>
          <h2
            className="mb-0 ml-auto m-2 text-primary"
            style={{ cursor: "pointer" }}
            onClick={() => setInfoModalOpen(true)}
          >
            <i className="fa fa-question-circle" aria-hidden="true"></i>
          </h2>{" "}
        </Row>

        <div className="text-center mb-3">
          <h1>Chat Rating</h1>
        </div>
        <Row className="justify-content-center ">
          <Col lg={4} sm={6} align="center">
            <div className="dashboard-card">
              <p className="dashboard-card-numbers--calculateathlete">
                {rating.satisfied} NO
              </p>
              <p className="dashboard-card-title--calculateathlete">%rated S</p>
            </div>
          </Col>
          <Col lg={4} sm={6} align="center">
            <div className="dashboard-card">
              <p className="dashboard-card-numbers--calculateathlete">
                {rating.NS} NO
              </p>
              <p className="dashboard-card-title--calculateathlete">
                %rated U-NS
              </p>
            </div>
          </Col>
          <Col lg={4} sm={6} align="center">
            <div className="dashboard-card">
              <p className="dashboard-card-numbers--calculateathlete">
                {rating.RST} NO
              </p>
              <p className="dashboard-card-title--calculateathlete">
                %rated U-RST
              </p>
            </div>
          </Col>
          <Col lg={4} sm={6} align="center">
            <div className="dashboard-card">
              <p className="dashboard-card-numbers--calculateathlete">
                {rating.none} NO
              </p>
              <p className="dashboard-card-title--calculateathlete">
                %No rating@1wk
              </p>
            </div>
          </Col>
          <Col lg={4} sm={6} align="center">
            <div className="dashboard-card">
              <p className="dashboard-card-numbers--calculateathlete">
                {rating?.total + rating?.none} NO
              </p>
              <p className="dashboard-card-title--calculateathlete">
                Chats total
              </p>
            </div>
          </Col>
        </Row>
      </Container>
      <TabsInfoModal
        setInfoModalOpen={setInfoModalOpen}
        infoModalOpen={infoModalOpen}
        data={infoPoints}
        title={infoTitle}
        subPoints={subPoints}
      />
    </>
  );
};

export default ChatRating;
